import { translate } from '../../ContentTranslation';
import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import Champion from './Champion';
import Entity from './Entity';
import './Fountain.css';

export default class Reward extends Component {

  state = {

    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    let tooltips = []

    let src = this.props.src;
    let manager = this.props.manager;

    return (
      <div className={"fountain-scene fight-scene " + (manager.controller.name)}>
        <div className="game-fountain">
          <Entity static src={ src.entity } onSelect={() => {}}/>
        </div>
        {
          src.active &&
          <div className="fountain-choices">
          {
            src.choices.map((c,i) => 
                <div key={i} className="fountain-choice" onClick={() => manager.run.room.fountain.select(c.type)}>
                  {
                      (() => {
                        switch (c.type) {
                        case "rest": return (
                          <div className="fountain-choice-inner">
                            <h3>{translate("Heal")}</h3>
                            <span>{translate("Recover ")}<span className="fountain-info-hp">{c.value}</span>{translate(" HP.")}</span>
                          </div>
                          );
                        case "worship": return (
                          <div className="fountain-choice-inner">
                            <h3>{translate("Worship")}</h3>
                            <span>{translate("Gain ")}<span className="fountain-info-exp">{c.value}</span>{translate(" exp.")}</span>
                          </div>
                          );
                        case "conjure": return (
                          <div className="fountain-choice-inner">
                            <h3>{translate("Conjure")}</h3>
                            <span>{translate("Add a new card to your deck.")}</span>
                          </div>
                          );
                        case "ponder": return (
                          <div className="fountain-choice-inner">
                            <h3>{translate("Ponder")}</h3>
                            <span>{translate("Watch a scene.")}</span>
                          </div>
                          );
                        case "purify": return (
                          <div className="fountain-choice-inner">
                            <h3>{translate("Purify")}</h3>
                            <span>{translate("Decrease your minimum deck size by 1.")}</span>
                          </div>
                          );
                        case "wish": return (
                          <div className="fountain-choice-inner">
                            <h3>{translate("Wish")}</h3>
                            <span>{translate("Get a random relic.")}</span>
                          </div>
                          );
                        case "cleanse": return (
                          <div className="fountain-choice-inner">
                            <h3>{translate("Cleanse")}</h3>
                            <span>{translate("Lose ")}<span className="fountain-info-corruption">{c.value}</span>{translate(" corruption.")}</span>
                          </div>
                          );
                        }
                      })()
                    }
                </div>
            )
          }
          </div>
        }
        {/*<div className="shop-sign">
          <div className="shop-name">{ "Fountain" }</div>
          <div className="shop-description">The air is quiet and the water is fresh, filled with magical energy. Help yourself, traveller.</div>
        </div>*/}
      </div>
    );
  }
}

